import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, withModifiers as _withModifiers, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f497e5ba"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-plus mr_5" }, null, -1))
const _hoisted_2 = {
  key: 1,
  class: "rel upload-exist flex-ter"
}
const _hoisted_3 = { class: "line--only mr_10 fcolor" }
const _hoisted_4 = ["onClick"]

import { ref, watch } from 'vue'
import { t } from '@/plugins/i18n'
import Upload from './Upload.vue'

export default /*#__PURE__*/_defineComponent({
  props: ['url', 'filename', 'limitFile'],
  emits: ['update:url', 'update:filename'],
  setup(__props, { expose, emit }) {

const props = __props



const data = ref(props.url)

watch(data, (val) => {
  if (val) {
    emit('update:url', val)
  }
})

const del: any = ref(null)

const replace = () => {
  if (props.url === data.value) {
    data.value = ''
    emit('update:url', '')
  }
  del.value && del.value()
}
expose({ replace })

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!

  return (!data.value)
    ? (_openBlock(), _createBlock(Upload, {
        key: 0,
        onChange: _cache[0] || (_cache[0] = (val) => (data.value = val?.raw?.url ?? '')),
        onGetName: _cache[1] || (_cache[1] = (val) => emit('update:filename', val)),
        limitFile: __props.limitFile
      }, {
        default: _withCtx(({ delFile }) => [
          _createVNode(_component_el_button, {
            type: "default",
            class: "upload-btn",
            onClick: ($event: any) => (del.value = delFile)
          }, {
            default: _withCtx(() => [
              _hoisted_1,
              _createElementVNode("span", null, _toDisplayString(_unref(t)('上传文件')), 1)
            ]),
            _: 2
          }, 1032, ["onClick"])
        ]),
        _: 1
      }, 8, ["limitFile"]))
    : (_openBlock(), _createElementBlock("div", _hoisted_2, [
        _renderSlot(_ctx.$slots, "default", {}, () => [
          _createElementVNode("label", _hoisted_3, _toDisplayString(__props.filename), 1)
        ]),
        _createElementVNode("i", {
          class: "btn fa fa-trash",
          onClick: _withModifiers(replace, ["stop"])
        }, null, 8, _hoisted_4)
      ]))
}
}

})